export class Default{
    id:number;
    seatOccupancyRateDefault:number|null;
    standingOccupancyRateDefault:number|null;
    personsBoardingDefault:number|null;
    personsDeboardingDefault:number|null;
    personValueFormatId:number|null;
    // personsPerSquareMeterEntranceDefault:number|null;
    // personsPerSquareMeterOtherDefault:number|null;
    personsPerSquareMeterEntranceArea:number|null;
    personsPerSquareMeterMultiPurposeArea:number|null;
    personsPerSquareMeterAisle:number|null;
}